(function(){
'use strict';
if(window.__CS_INITIALIZING__||window.__CS_BOOTED__)return;
window.__CS_INITIALIZING__=true;
function waitForData(timeout){return new Promise(function(res){var t0=Date.now();(function p(){if(window.CS_DATA)return res(true);if(Date.now()-t0>=timeout)return res(false);setTimeout(p,100)})()})}
function fail(){window.__CS_INITIALIZING__=false;if(window.__csFallback)window.__csFallback()}
function init(){
var D=window.CS_DATA;

var TAGS=D.tags, ST=D.stories, CFG=D.cfg, PRODS=D.prods, IMG=D.imgBase;
var $=function(s){return document.querySelector(s)};
var grid=$('#storyGrid'), heading=$('#storyHeading'), loadBtn=$('#csLoadMore'),
    summary=$('#csSummary'), rmeta=$('#csResultMeta'), tgWrap=$('#csThemeGroups'),
    prevNote=$('#csPrevNote'), emptyBox=$('#csEmpty');
var dim='size', sel=null, prev=null, shown=12;
function en(i){var t=TAGS[i];return t?t.en:null}
function escq(s){return String(s==null?'':s).replace(/[&<>"']/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]})}
function stars(r){return '★★★★★☆☆☆☆☆'.slice(5-r,10-r)}
function score(s){return (s.p.length?80:0)+Math.min(s.t.length,500)/10+(s.nd.length+s.po.length+s.who.length)*7+(s.ca.length?8:0)}
function matches(s){
 if(!sel) return true;
 if(sel.kind==='model') return s.m===sel.m;
 if(sel.kind==='size') return s.s===sel.v;
 if(sel.kind==='needMain') return sel.t.some(function(i){return s.nd.indexOf(i)>=0});
 if(sel.kind==='tag'){
   if(sel.g==='who') return s.who[0]===sel.i;
   if(sel.g==='need') return s.nd.indexOf(sel.i)>=0;
   if(sel.g==='positive') return s.po.indexOf(sel.i)>=0;
   if(sel.g==='caution') return s.ca.indexOf(sel.i)>=0;
 }
 return true;
}
function list(){return ST.filter(matches).sort(function(a,b){return score(b)-score(a)})}
function cardHTML(s,compact){
 var img='';
 if(s.p.length&&!compact){
  img='<div class="sc-img"><img src="'+IMG+escq(s.p[0])+'" width="600" height="450" loading="lazy" alt="Customer photo of the Irene House '+escq(s.m)+' lift recliner at home" onerror="this.closest(\'.sc-img\').remove()"></div>';
 }else if(s.v&&!compact){
  img='<div class="sc-img video"><img src="'+IMG+escq(s.v)+'" width="600" height="450" loading="lazy" alt="Video review of the Irene House '+escq(s.m)+' lift recliner" onerror="this.closest(\'.sc-img\').remove()"><span class="play-badge" aria-hidden="true">▶</span></div>';
 }
 var chips=['<span class="cs-bg dark">'+escq(s.m)+'</span>'];
 if(s.s)chips.push('<span class="cs-bg">'+escq(s.s)+'</span>');
 if(s.h)chips.push('<span class="cs-bg line">'+escq(s.h)+'</span>');
 var who=null;for(var i=0;i<s.who.length;i++){if(en(s.who[i])!=='For Myself / Not Stated'){who=s.who[i];break}}
 if(who!=null)chips.push('<span class="cs-bg line">'+escq(en(who))+'</span>');
 if(s.nd.length)chips.push('<span class="cs-bg need">'+escq(en(s.nd[0]))+'</span>');
 var pos=s.po.slice(0,3).map(function(i){return '<span class="cs-bg soft">'+escq(en(i))+'</span>'}).join('');
 if(s.ca.length)pos+='<span class="cs-bg consider">Something to consider</span>';
 var text=compact?(s.t.slice(0,220)+(s.t.length>220?'…':'')):s.t;
 var p=PRODS[s.m];
 var link=p?'<a class="sc-link" href="'+escq(p.url)+'" target="_blank" rel="noopener">View chair details →</a>':'';
 var media=s.v?' · Video review':(s.p.length?' · Photo review':'');
 return '<article class="sc'+(compact?' compact':'')+'" data-id="'+escq(s.i)+'">'+img+
  '<div class="sc-body"><div class="sc-chips">'+chips.slice(0,5).join('')+'</div>'+
  '<div class="sc-meta">'+escq(s.d)+' · <span class="sc-stars">'+stars(s.r)+'</span>'+
  media+(s.w?' · '+escq(s.w):'')+'</div>'+
  '<p class="sc-quote">“'+escq(text)+'”</p><div class="sc-pos">'+pos+'</div>'+
  '<div class="sc-foot"><span class="sc-purchase">Purchased: '+escq(s.m)+(s.s?' '+escq(s.s):'')+'</span>'+
  '<span class="sc-actions">'+link+'<button type="button" class="sc-open" data-id="'+escq(s.i)+'">Read full review →</button></span></div></div></article>';
}
function themeGroups(L){
 var counts={};
 function add(g,i){var k=g+'|'+i;counts[k]=(counts[k]||0)+1}
 L.forEach(function(s){
  if(s.who.length&&en(s.who[0])!=='For Myself / Not Stated')add('who',s.who[0]);
  s.nd.forEach(function(i){add('need',i)});
  s.po.forEach(function(i){add('positive',i)});
  s.ca.forEach(function(i){add('caution',i)});
 });
 var groups={who:[],need:[],positive:[],caution:[]};
 Object.keys(counts).forEach(function(k){
  var p=k.split('|'),g=p[0],i=+p[1];
  groups[g].push({i:i,g:g,n:counts[k],en:en(i)});
 });
 Object.keys(groups).forEach(function(g){groups[g].sort(function(a,b){return b.n-a.n})});
 return groups;
}
function chipHTML(x,extra){
 var act=sel&&sel.kind==='tag'&&sel.i===x.i;
 return '<button type="button" class="cs-chip'+(extra||'')+(act?' active':'')+'" data-tag="'+x.i+'" data-g="'+x.g+'">'+escq(x.en)+' <b>'+x.n+'</b></button>';
}
function renderSummary(L){
 if(!sel){summary.classList.remove('show');prevNote.classList.remove('show');return}
 summary.classList.add('show');
 rmeta.textContent=L.length+' matching reviews · topic: '+sel.label;
 var g=themeGroups(L),html='',extra='';
 function lineHTML(label,items,cls){
  if(!items.length)return '';
  return '<div class="tg-line"><span class="tg-label">'+label+'</span>'+items.map(function(x){return chipHTML(x,cls||'')}).join('')+'</div>';
 }
 if(sel.kind==='needMain'&&sel.k==='surgery'){
  var subs=CFG.surgerySub.map(function(x){return {i:x.t,g:'need',n:x.n,en:x.en}});
  html+=lineHTML('Type of surgery',subs);
 }
 var titles={who:'Who it was for',need:'Why they bought it',positive:'Customers appreciated'};
 ['who','need','positive'].forEach(function(k){
  var all=g[k].filter(function(x){return x.n>=2&&!(sel.kind==='tag'&&sel.i===x.i)});
  html+=lineHTML(titles[k],all.slice(0,4));
  if(all.length>4)extra+=lineHTML(titles[k],all.slice(4));
 });
 var consAll=g.caution.filter(function(x){return x.n>=2&&!(sel.kind==='tag'&&sel.i===x.i)});
 html+=lineHTML('Things to consider',consAll.slice(0,4),' cs-consider-chip');
 if(consAll.length>4)extra+=lineHTML('Things to consider',consAll.slice(4),' cs-consider-chip');
 if(extra)html+='<button type="button" class="tg-more" id="csMoreTopics">More topics ▾</button>'+
  '<div class="tg-extra" id="csExtraTopics" hidden>'+extra+'</div>';
 tgWrap.innerHTML=html;
 var mt=document.getElementById('csMoreTopics');
 if(mt)mt.onclick=function(){var x=document.getElementById('csExtraTopics');x.hidden=!x.hidden;
  mt.textContent=x.hidden?'More topics ▾':'Fewer topics ▴'};
 tgWrap.querySelectorAll('.cs-chip').forEach(function(b){
  b.onclick=function(){
   prev=sel;
   sel={kind:'tag',i:+b.dataset.tag,g:b.dataset.g,label:en(+b.dataset.tag)};
   shown=12;renderAll();
   if(prev&&prev.label!==sel.label){
    prevNote.classList.add('show');
    prevNote.innerHTML='<span>Now viewing stories about <strong>'+escq(sel.label)+'</strong> across the full review library. Previously viewing: '+escq(prev.label)+'</span><button type="button" class="clear-btn" id="csBack">← Back to '+escq(prev.label)+'</button>';
    var bk=document.getElementById('csBack');
    if(bk)bk.onclick=function(){sel=prev;prev=null;shown=12;renderAll()};
   }
   document.getElementById('stories').scrollIntoView({behavior:'smooth'});
  };
 });
}
function renderStories(){
 var L=list(),vis=L.slice(0,shown);
 heading.textContent=sel?sel.label+' — customer stories':'Featured experiences';
 grid.innerHTML=vis.map(function(s){return cardHTML(s,false)}).join('');
 emptyBox.classList.toggle('show',!L.length);
 loadBtn.style.display=shown<L.length?'block':'none';
 loadBtn.textContent='Show more stories ('+(L.length-shown)+' remaining)';
 bindOpen(grid);renderSummary(L);
}
function markActive(){
 document.querySelectorAll('.cs-choice').forEach(function(b){
  var on=false;
  if(sel){
   if(sel.kind==='size')on=b.dataset.size===sel.v;
   else if(sel.kind==='model')on=b.dataset.model===sel.m;
   else if(sel.kind==='needMain')on=b.dataset.needKey===sel.k;
   else if(sel.kind==='tag')on=b.dataset.who===String(sel.i);
  }
  b.classList.toggle('active',on);
 });
}
function renderAll(){markActive();renderStories()}
document.querySelectorAll('.dim-btn').forEach(function(b){
 b.onclick=function(){
  dim=b.dataset.dim;
  document.querySelectorAll('.dim-btn').forEach(function(x){x.classList.toggle('active',x===b)});
  document.querySelectorAll('.cs-choice-grid').forEach(function(gd){gd.hidden=gd.dataset.dim!==dim});
 };
});
document.querySelectorAll('.cs-choice').forEach(function(b){
 b.onclick=function(){
  prev=null;prevNote.classList.remove('show');shown=12;
  var same=b.classList.contains('active');
  if(same){sel=null;renderAll();return}
  if(b.dataset.size)sel={kind:'size',v:b.dataset.size,label:b.dataset.size+' size'};
  else if(b.dataset.model)sel={kind:'model',m:b.dataset.model,label:b.dataset.model};
  else if(b.dataset.needKey){var nm=CFG.needMain.filter(function(x){return x.k===b.dataset.needKey})[0];sel={kind:'needMain',k:nm.k,t:nm.t,label:nm.en}}
  else if(b.dataset.who)sel={kind:'tag',i:+b.dataset.who,g:'who',label:en(+b.dataset.who)};
  renderAll();
  document.getElementById('stories').scrollIntoView({behavior:'smooth'});
 };
});
var cb=$('#csClear'); if(cb)cb.onclick=function(){sel=null;prev=null;shown=12;prevNote.classList.remove('show');renderAll()};
loadBtn.onclick=function(){shown+=12;renderStories()};
document.querySelectorAll('.see-all').forEach(function(b){
 b.onclick=function(){
  var nm=CFG.needMain.filter(function(x){return x.k===b.dataset.needKey})[0];
  if(!nm)return;
  dim='need';sel={kind:'needMain',k:nm.k,t:nm.t,label:nm.en};prev=null;shown=12;
  document.querySelectorAll('.dim-btn').forEach(function(x){x.classList.toggle('active',x.dataset.dim==='need')});
  document.querySelectorAll('.cs-choice-grid').forEach(function(gd){gd.hidden=gd.dataset.dim!=='need'});
  renderAll();
  document.getElementById('stories').scrollIntoView({behavior:'smooth'});
 };
});
/* ---- Modal ---- */
var modal=$('#csModal'),dialog=$('#csDialog'),lastFocus=null;
function byId(id){for(var i=0;i<ST.length;i++)if(ST[i].i===id)return ST[i];return null}
function openModal(id){
 var s=byId(id);if(!s)return;
 lastFocus=document.activeElement;
 var facts=['<span class="cs-bg dark">'+escq(s.m)+'</span>'];
 if(s.s)facts.push('<span class="cs-bg">'+escq(s.s)+'</span>');
 if(s.h)facts.push('<span class="cs-bg line">Height '+escq(s.h)+'</span>');
 if(s.w)facts.push('<span class="cs-bg line">Weight '+escq(s.w)+'</span>');
 s.who.forEach(function(i){if(en(i)!=='For Myself / Not Stated')facts.push('<span class="cs-bg line">'+escq(en(i))+'</span>')});
 s.nd.forEach(function(i){facts.push('<span class="cs-bg need">'+escq(en(i))+'</span>')});
 s.po.forEach(function(i){facts.push('<span class="cs-bg soft">'+escq(en(i))+'</span>')});
 s.ca.forEach(function(i){facts.push('<span class="cs-bg consider">'+escq(en(i))+'</span>')});
 var imgs=s.p.map(function(u){
  var base=IMG+u,hi=base.replace(/\.jpg$/i,'_orig.jpg');
  return '<img src="'+escq(hi)+'" loading="lazy" width="800" height="600" class="cs-zoomable" alt="Customer photo of the Irene House '+escq(s.m)+' lift recliner" title="Click to enlarge" onerror="if(this.src!==\''+escq(base)+'\'){this.src=\''+escq(base)+'\'}else{this.remove()}">';
 }).join('');
 var video='';
 if(s.v){
  var vp=PRODS[s.m];
  var vhref=vp?vp.url+'#looxReviews':'/collections/power-lift-chairs';
  video='<div class="cs-video"><img src="'+IMG+escq(s.v)+'" loading="lazy" width="800" height="600" alt="Video review of the Irene House '+escq(s.m)+' lift recliner"><a class="cs-watch" href="'+escq(vhref)+'" target="_blank" rel="noopener">▶ Watch this video on the product page</a><p class="cs-video-note">Customer videos play in the reviews section of the product page.</p></div>';
 }
 var p=PRODS[s.m],prod;
 if(p){
  prod='<div class="cs-prod">'+(p.img?'<img src="'+escq(p.img)+'" width="64" height="64" alt="">':'')+
   '<div><div class="t">'+escq(p.title)+'</div><div class="s">Currently available</div></div>'+
   '<a href="'+escq(p.url)+'" target="_blank" rel="noopener">View full product page →</a></div>';
 }else{
  prod='<div class="cs-prod"><div><div class="t">'+escq(s.m)+'</div><div class="s">This exact model is no longer sold.</div></div>'+
   '<a href="/collections/power-lift-chairs" target="_blank" rel="noopener">Browse current lift chairs →</a></div>';
 }
 dialog.innerHTML='<button type="button" class="cs-close" id="csClose" aria-label="Close">✕</button>'+
  '<div class="sc-meta">'+escq(s.d)+' · <span class="sc-stars">'+stars(s.r)+'</span> · Verified purchase</div>'+
  '<div class="cs-facts">'+facts.join('')+'</div>'+
  video+(imgs?'<div class="cs-imgs">'+imgs+'</div>':'')+
  '<div class="cs-text">“'+escq(s.t)+'”</div>'+prod;
 modal.classList.add('open');document.body.style.overflow='hidden';
 history.replaceState(null,'','#story-'+s.i);
 $('#csClose').onclick=closeModal;$('#csClose').focus();
 dialog.querySelectorAll('.cs-zoomable').forEach(function(im){im.onclick=function(){openLightbox(im.src,im.alt)}});
}
/* ---- image lightbox ---- */
var lightbox=$('#csLightbox');
function openLightbox(src,alt){
 lightbox.innerHTML='<img src="'+escq(src)+'" alt="'+escq(alt||'')+'"><button type="button" class="cs-close lb-close" aria-label="Close">✕</button>';
 lightbox.classList.add('open');
 lightbox.querySelector('.lb-close').onclick=closeLightbox;
}
function closeLightbox(){lightbox.classList.remove('open');lightbox.innerHTML=''}
lightbox.addEventListener('click',function(e){if(e.target===lightbox||e.target.tagName==='IMG')closeLightbox()});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&lightbox.classList.contains('open')){e.stopImmediatePropagation();closeLightbox()}});
function closeModal(){
 modal.classList.remove('open');document.body.style.overflow='';
 history.replaceState(null,'',location.pathname+location.search);
 if(lastFocus)lastFocus.focus();
}
modal.addEventListener('click',function(e){if(e.target===modal)closeModal()});
document.addEventListener('keydown',function(e){
 if(!modal.classList.contains('open'))return;
 if(lightbox&&lightbox.classList.contains('open'))return;
 if(e.key==='Escape')closeModal();
 if(e.key==='Tab'){
  var f=dialog.querySelectorAll('button,a[href]');
  if(!f.length)return;
  var first=f[0],last=f[f.length-1];
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
 }
});
function bindOpen(root){
 root.querySelectorAll('.sc-open').forEach(function(b){b.onclick=function(){openModal(b.dataset.id)}});
 root.querySelectorAll('.sc-img').forEach(function(w){
  w.style.cursor='zoom-in';
  w.onclick=function(){var a=w.closest('.sc');if(a)openModal(a.dataset.id)};
 });
}
bindOpen(document);
var _pm=new URLSearchParams(location.search).get('model');
if(_pm){var hit=ST.some(function(x){return x.m===_pm});if(hit){sel={kind:'model',m:_pm,label:'Reviews for '+_pm};shown=12;renderAll();}}
if(location.hash.indexOf('#story-')===0)openModal(location.hash.slice(7));
loadBtn.style.display=ST.length>12?'block':'none';
loadBtn.textContent='Show more stories ('+(ST.length-12)+' remaining)';
window.__csBooted=true;
if(window.__csReplay)window.__csReplay();
window.__CS_BOOTED__=true;window.__CS_INITIALIZING__=false;
}
waitForData(4000).then(function(ok){
if(!ok){fail();return}
try{init()}catch(err){fail();throw err}
});
})();
